import { useCallback, useState, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./Kyc.module.css";
import { useNavigate } from "react-router";
import axios from "axios";
import { observer } from "mobx-react";
import config from "../../config/config";
import store from "../../Store/Store";
import { Pagination } from "antd";
import NewUsers from "../Users/newUsers/NewUsers";
import KycStatus from "./Kyc_Status/KycStatus";
import Notificatio from "../Users/Notification/Notificatio";
import KycResend from "../Users/KycResend/KycResend";
import { useSearchParams } from "react-router-dom";
import NewUserPopup1 from "../Transaction/NewUserPopup/NewUserPopup";
import NewUserPopup from "../AddUsers/NewUserModal/NewUserModal";
import { jwtDecode } from "jwt-decode";
import {
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
  RespondToAuthChallengeCommand,
} from "@aws-sdk/client-cognito-identity-provider";

const Kyc = observer(({ className = "" }) => {
  const [searchParams] = useSearchParams();
  const [flag, setFlag] = useState(false);
  const [flagNotifi, setFlagNotifi] = useState(false);
  const [data, setData] = useState([]);
  const [WalletInfo, setWalletinfo] = useState("Loading...");
  const [serchFilter, setSerchFilter] = useState("");
  const [companyname, setcompanyname] = useState("");
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [refresh, setRefresh] = useState(true);
  const [Kyctype, SetKycType] = useState("pending");
  const [newFlag, setNewFlag] = useState(false);
  const [allData, setAllData] = useState([]);
  const [ResendReq, setResendReq] = useState(false);
  const [isViewAdmin, setViewAdmin] = useState(false);
  const [isUser, setIsUser] = useState(false);
  const [newUser, setNewUser] = useState(true);
  const [newUser1, setNewUser1] = useState(true);
  const [popup, setPopup] = useState(false);
  const [isAdmin, setisAdmin] = useState(false);
  const [showBanner, setShowBanner] = useState(false);
  const [advKycStatus, setAdvKycStatus] = useState("");
  const [whitelistingStatus, setWhitelistingStatus] = useState("");
  const [onboardingStatus, setOnboardingStatus] = useState("");
  const banner = searchParams.get("banner");

  useEffect(() => {
    setPopup(banner);
  }, [banner]);

  useEffect(() => {
    if (!store.Company_Id) return;

    const fetchStatus = async () => {
      // setLoading(true);
      // setError("");
      try {
        let tokens = localStorage.getItem("authToken");
        let parsedTokens = JSON.parse(tokens);
        const res = await fetch(
          `${config.kyc_api_endpoint}/user/status?company_id=${store.Company_Id}`,
          {
            method: "POST", // ← changed to POST
            headers: {
              "Content-Type": "application/json",
              aws_cognito_id_token: parsedTokens.IdToken,
              aws_cognito_access_token: parsedTokens.AccessToken,
            },
            body: JSON.stringify({
              company_id: store.Company_Id,
              kyc_company_id: store.KycCompanyId,
            }),
          },
        );

        const data = await res.json();
        const statusMap = Object.fromEntries(
          data.status.map((s) => [s.key, s.value]),
        );
        console.log("RESPONSE_________>", data);

        setAdvKycStatus(statusMap["advanced-kyc"]);
        setWhitelistingStatus(statusMap["whitelisting"]);
        setOnboardingStatus(data.onboarding_status);
        store.setCompTempId(data.company_id);
        store.setKycCompanyId(data?.company_id);
        store.setTradeName(data.trade_name);
        if (!res.ok || !data.success) {
          throw new Error(data.error || "Failed to fetch status");
        }

        // setStatus(data.status);
        // setOnboardingStatus(data.onboarding_status);
      } catch (err) {
        if (err.name !== "AbortError") {
          // setError(err.message || "Something went wrong");
        }
      } finally {
        // setLoading(false);
      }
    };

    fetchStatus();
  }, [store.company_temp_id, store.refresh]);

  const onAddNewUsersClick = useCallback(() => {
    setFlag(true);
  }, []);

  useEffect(() => {
    let auth = localStorage.getItem("authToken");
    if (!auth) {
      navigate("/login");
      return;
    }
    GetkycStatus("pending");
  }, []); //flagNotifi, refresh, store.refresh

  useEffect(() => {
    try {
      let tokens = localStorage.getItem("authToken");
      let parsedTokens = JSON.parse(tokens);
      const expired = isTokenExpired(parsedTokens.IdToken);
      if (expired) {
        parsedTokens = getNewTokens(parsedTokens);
      }
      const obj = {
        ledger_label: store.Company_Id,
      };
      let payload = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${config.node_api_endpoint}/cupi/admin/get_cupi_company_detail`,
        headers: {
          aws_cognito_id_token: parsedTokens.IdToken,
          aws_cognito_access_token: parsedTokens.AccessToken,
          "Content-Type": "application/json",
        },
        data: obj,
      };

      axios
        .request(payload)
        .then((res) => {
          setWalletinfo(res.data.data);
          store.setInsightAvilable(res.data.data.metabase_account_created);
        })
        .catch((er) => {
          console.log("error-->", er);
        });
      setCompany(store.companyName);
    } catch (err) {
      console.log("Error in walletInfo", err);
    }
  }, []);

  const isTokenExpired = (token) => {
    try {
      const decoded = jwtDecode(token);

      if (decoded && decoded.exp) {
        const currentTime = Math.floor(Date.now() / 1000); // Get current time in seconds
        return decoded.exp < currentTime;
      }
    } catch (error) {
      console.log("Error decoding token:", error);
      return true; // Treat decoding failures as expired tokens
    }
    return true;
  };

  const getNewTokens = async (authData) => {
    if (!authData?.RefreshToken) {
      localStorage.removeItem("authToken");
      // navigate("/login");
      return;
    }

    try {
      const client = new CognitoIdentityProviderClient({
        region: "ap-south-1",
      });

      const params = {
        ClientId: config.Client_Id,
        AuthFlow: "REFRESH_TOKEN_AUTH",
        AuthParameters: {
          REFRESH_TOKEN: authData?.RefreshToken,
        },
      };

      const command = new InitiateAuthCommand(params);
      const refreshResponse = await client.send(command);

      if (refreshResponse.AuthenticationResult) {
        const newAuthToken = {
          AccessToken: refreshResponse.AuthenticationResult.AccessToken,
          RefreshToken: authData?.RefreshToken, // Keep old refresh token
          IdToken: refreshResponse.AuthenticationResult.IdToken,
        };

        localStorage.setItem("authToken", JSON.stringify(newAuthToken));
        setAuth(newAuthToken); // Update state
        if (store.refresh) {
          store.setRefresh(false);
        } else {
          store.setRefresh(true);
        }
        return newAuthToken;
      } else {
        localStorage.removeItem("authToken");
        // navigate("/login");
      }
    } catch (error) {
      console.log("Error refreshing tokens:", error);
      localStorage.removeItem("authToken");
      // navigate("/login");
    }
  };

  const GetkycStatus = (status) => {
    const obj = {
      ledger_label: store.Company_Id,
      status: status,
    };

    let tokens = localStorage.getItem("authToken");
    let parsedTokens = JSON.parse(tokens);

    let payload = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${config.node_api_endpoint}/cupi/admin/pine/get_users_kyc`,
      headers: {
        aws_cognito_id_token: parsedTokens.IdToken,
        aws_cognito_access_token: parsedTokens.AccessToken,
        "Content-Type": "application/json",
      },
      data: obj,
    };
    console.log("objjjjjj---->", obj);
    const expired = isTokenExpired(parsedTokens.IdToken);
    if (expired) {
      parsedTokens = getNewTokens(parsedTokens);
    }
    axios
      .request(payload)
      .then((res) => {
        if (Array.isArray(res.data.data)) {
          console.log("res.data", res.data);

          setData(res.data.data);
          setAllData(res.data.data);
        } else {
          console.warn("Unexpected response format:", res.data.data);
        }
      })
      .catch((err) => {
        console.log("Error fetching KYC status:", err.message);
        // Optionally show a UI error message (e.g., "Failed to fetch KYC status")
      });
  };

  const filteredData = data.filter(
    (user) =>
      user?.user_name?.toLowerCase()?.includes(serchFilter?.toLowerCase()) ||
      user?.user_email?.toLowerCase()?.includes(serchFilter?.toLowerCase()) ||
      user?.user_mobile_no?.includes(serchFilter),
  );

  const resendKycLink = async (detail) => {
    try {
      console.log("details----->", detail);
      const rawAuth = localStorage.getItem("authToken");
      let parsedTokens = rawAuth ? JSON.parse(rawAuth) : {};
      let obj = {
        initiate_kyc_bp_response: detail.initiate_kyc_bp_response,
        kyc_initiate_on: detail.kyc_initiate_on,
        user_mobile_no: detail.user_mobile_no,
        ledger_label: store.Company_Id,
      };
      const expired = isTokenExpired(parsedTokens?.IdToken);
      if (expired) {
        parsedTokens = getNewTokens(parsedTokens);
      }

      let payload = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${config.node_api_endpoint}/cupi/admin/refresh_expired_link_and_resend_kyc_link`,
        headers: {
          aws_cognito_id_token: parsedTokens.IdToken,
          aws_cognito_access_token: parsedTokens.AccessToken,
          "Content-Type": "application/json",
        },
        data: obj,
      };
      axios
        .request(payload)
        .then((res) => {
          setResendReq(true);
          GetkycStatus("Expired");
        })
        .catch((err) => {
          console.log("error: %o".err);
        });
    } catch (err) {
      console.log("err", err);
    }
  };
  useEffect(() => {
    if (store.userType == "AxisUser") {
      navigate("/");
    }
  }, [store.Company_Id]);

  const startIndex = (currentPage - 1) * pageSize;
  let currentPageData = filteredData
    .reverse()
    .slice(startIndex, startIndex + pageSize);

  const handlePaginationChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  return (
    <>
      <div className={styles.pageContainer + " " + className}>
        <div className={styles.frameParent}>
          <div className={styles.cards16pxContainer}>
            <div className={styles.cards16px}>
              <div className={styles.saveMoney1044644423Parent}>
                <div className={styles.saveMoney1044644423}>
                  <img className={styles.vectorIcon} alt="" src="/vector.svg" />
                </div>
                <div className={styles.availableBalanceParent}>
                  <div className={styles.availableBalance}>
                    Available Balance*
                  </div>
                  <div className={styles.div}>
                    ₹{WalletInfo.balance || "Loading..."}
                  </div>
                </div>
              </div>

              {store.Company_Id != "AxisDemo" && (
                <div className={styles.saveMoney1044644423Parent1}>
                  <div className={styles.saveMoney1044644423row}>
                    <div className={styles.saveMoney1044644423}>
                      <img
                        className={styles.vectorIcon}
                        alt=""
                        src="/wallet.svg"
                      />
                    </div>
                    <div className={styles.availableBalanceParent1}>
                      <div className={styles.availableBalance}>
                        Account Details*
                        <div className={styles.tiptool}>
                          {/* <img
                              src="/alert-circle.svg"
                              alt=""
                              className={styles.icon}
                            />
                            <span className={styles.Texttooltip}>
                              Please load money only from company's validated
                              Bank account to the wallet.
                            </span> */}
                        </div>
                      </div>

                      <div className={styles.div16}>
                        <div>Ac.no</div>
                        <div>:</div>
                        <div>{WalletInfo?.van?.acc_no || "Loading..."}</div>
                      </div>
                      <div className={styles.div16}>
                        <div>IFSC</div>
                        <div>:</div>
                        <div>{WalletInfo?.van?.ifsc || "Loading..."}</div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.RedirectLink} onClick={()=>{ navigate("/content/kycValidation?tab=2");}}>
                    How to load money? Click here
                  </div>
                </div>
              )}
            </div>
            {!showBanner && (
              <NewUserPopup1
                advKycStatus={advKycStatus}
                whitelistingStatus={whitelistingStatus}
                onboardingStatus={onboardingStatus}
                setShowBanner={setShowBanner}
                showOthers={false}
              />
            )}
          </div>

          <div className={styles.frameGroup}>
            <div className={styles.filterContainer}>
              <div
                className={
                  Kyctype == "pending"
                    ? styles.filterContainerItemsActive
                    : styles.filterContainerItems
                }
                onClick={() => {
                  SetKycType("pending");
                  GetkycStatus("pending");
                  setData([]);
                  setAllData([]);
                }}
              >
                Pending
              </div>
              <div className={styles.filterContainerBlocks}></div>
              <div
                className={
                  Kyctype == "Expired"
                    ? styles.filterContainerItemsActive
                    : styles.filterContainerItems
                }
                onClick={() => {
                  SetKycType("Expired");
                  GetkycStatus("Expired");

                  setData([]);
                  setAllData([]);
                }}
              >
                Expired
              </div>
              <div className={styles.filterContainerBlocks}></div>
              <div
                className={
                  Kyctype == "Rejected"
                    ? styles.filterContainerItemsActive
                    : styles.filterContainerItems
                }
                onClick={() => {
                  SetKycType("Rejected");
                  GetkycStatus("Rejected");
                  setData([]);
                  setAllData([]);
                }}
              >
                Rejected
              </div>

              <div className={styles.welcomesunshineinfotechWrapper}>
                {!store.isUserViewAdmin && !store.isUserGlobalViewAdmin && (
                  <button
                    className={styles.addNewUsers}
                    onClick={onAddNewUsersClick}
                  >
                    <img
                      className={styles.plusCircleIcon}
                      alt=""
                      src="/pluscircle.svg"
                    />
                    <b className={styles.newUser}>New KYC Request</b>
                  </button>
                )}
              </div>
            </div>
            <div className={styles.feeStatementDataTable}>
              <div className={styles.top}>
                <div className={styles.filterWrapper}>
                  <div className={styles.filter}>
                    {Kyctype == "pending" ? (
                      <div className={styles.containertext}>
                        Pending KYC List
                      </div>
                    ) : Kyctype == "Expired" ? (
                      <div className={styles.containertext}>
                        Expired KYC List
                      </div>
                    ) : (
                      <div className={styles.containertext}>
                        Rejected KYC List
                      </div>
                    )}
                  </div>
                  <div className={styles.filter}>
                    <div className={styles.textField}>
                      <div className={styles.content}>
                        <img
                          className={styles.leadingIcon}
                          alt=""
                          src="/leadingicon.svg"
                        />
                        <input
                          className={styles.labelText1}
                          placeholder="Search..."
                          type="text"
                          value={serchFilter}
                          onChange={(e) => {
                            setSerchFilter(e.target.value);
                          }}
                        />
                      </div>
                    </div>

                    <button
                      className={styles.reLoadTable}
                      onClick={() => {
                        GetkycStatus(Kyctype);
                      }}
                    >
                      <img
                        className={styles.vectorIcon1}
                        alt=""
                        src="/vector7.svg"
                      />
                    </button>
                  </div>
                </div>
              </div>
              <table className={styles.table}>
                <thead className={styles.tableHead}>
                  <tr className={styles.tableHeaderRow}>
                    <th className={styles.tableHeaderRowCell}>
                      <div className={styles.head}>Created date</div>
                    </th>
                    <th className={styles.tableHeaderRowCell}>
                      <div className={styles.head}>Name</div>
                    </th>
                    <th className={styles.tableHeaderRowCell}>
                      <div className={styles.head}>Email</div>
                    </th>

                    <th className={styles.tableHeaderRowCell}>
                      <div className={styles.head}>Phone no </div>
                    </th>

                    <th className={styles.tableHeaderRowCell}>
                      <div className={styles.head}>KYC Status</div>
                    </th>
                    <th className={styles.tableHeaderRowCell}>
                      <div className={styles.head}>Action</div>
                    </th>
                  </tr>
                </thead>
                <tbody className={styles.tableHead}>
                  {currentPageData.map((detail, index) => (
                    <tr key={index} className={styles.tableBodyrow}>
                      <td className={styles.tableBodydata}>
                        {" "}
                        <div className={styles.data1}>
                          {detail.kyc_initiate_on}
                        </div>
                      </td>
                      <td className={styles.tableBodydata}>
                        {" "}
                        <div className={styles.data1}>{detail.user_name}</div>
                      </td>
                      <td className={styles.tableBodydata}>
                        {" "}
                        <div className={styles.data1}>{detail.user_email}</div>
                      </td>
                      <td className={styles.tableBodydata}>
                        {" "}
                        <div className={styles.data}>
                          {detail.user_mobile_no}
                        </div>
                      </td>
                      <td className={styles.tableBodydata}>
                        <div className={styles.data}>
                          {" "}
                          {Kyctype.toUpperCase()}{" "}
                        </div>
                      </td>
                      <td className={styles.tableBodydata}>
                        <button className={styles.button}>
                          <img
                            alt=""
                            src="/eye.svg"
                            className={styles.btn_img}
                            onClick={() => {
                              store.setName(detail.user_name); //
                              store.setSelectedEmail(detail.user_email); //
                              store.setKycStatus(Kyctype); //
                              store.setCreate_at(detail.kyc_initiate_on); //
                              store.setPhoneNo(detail.user_mobile_no); //

                              store.setKycRejectedReason(detail.reason); //**
                              store.setTxnLimit(detail.per_transaction_limit);
                              store.setDailyLimit(detail.dailty_limit);
                              store.setmonthlyLimit(detail.monthly_limit);
                              store.setTags(detail.tags);
                              setNewFlag(true);
                            }}
                          />
                          {Kyctype != "pending" &&
                            !store.isUserViewAdmin &&
                            !store.isUserGlobalViewAdmin && (
                              <div className={styles.btn_text1}>/</div>
                            )}
                          {Kyctype != "pending" &&
                            !store.isUserViewAdmin &&
                            !store.isUserGlobalViewAdmin && ( //DONT ALLOW VIEW ADMIN
                              <div
                                className={styles.btn_text}
                                onClick={async () => {
                                  resendKycLink(detail);
                                }}
                              >
                                Re-send
                              </div>
                            )}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className={styles.bottom}>
                <Pagination
                  current={currentPage}
                  pageSize={pageSize}
                  total={filteredData.length}
                  onChange={handlePaginationChange}
                  // showSizeChanger
                />
              </div>
            </div>
          </div>
        </div>
        {(popup || flag) && (
          <div
            className={styles.newUsersOverlay}
            onClick={() => {
              // setFlag(false);
            }}
          >
            <NewUsers
              isVisible={popup || flag}
              onClose={() => {
                setFlag(false);
                setPopup(false);
              }}
              setAdmin={() => {
                setisAdmin(true);
              }}
              openNoti={() => {
                setFlagNotifi(true);
              }}
              resetAdmin={() => {
                setisAdmin(false);
              }}
              setViewAdmin={() => {
                setViewAdmin(true);
              }}
              setUserAccess={() => {
                setIsUser(true);
              }}
            />
          </div>
        )}
        {newFlag && (
          <div
            className={styles.newUsersOverlay}
            onClick={() => {
              setNewFlag(false);
            }}
          >
            <KycStatus isVisible={newFlag} onClose={() => setNewFlag(false)} />
          </div>
        )}

        {flagNotifi && (
          <div
            className={styles.newUsersOverlay1}
            onClick={() => {
              setFlagNotifi(false);
              store.setInitiateKYC("");
            }}
          >
            <Notificatio
              isVisible={flagNotifi}
              onClose={() => {
                setFlagNotifi(false);
                store.setInitiateKYC("");
              }}
              isAdmin={isAdmin}
              isViewAdmin={isViewAdmin}
              isUser={isUser}
            />
          </div>
        )}
        {ResendReq && (
          <div
            className={styles.newUsersOverlay1}
            onClick={() => {
              setResendReq(false);
            }}
          >
            <KycResend
              isVisible={ResendReq}
              onClose={() => {
                setResendReq(false);
              }}
            />
          </div>
        )}
      </div>
      {banner && (
        <NewUserPopup
          isOpen={newUser || newUser1}
          showGuideCard={newUser1}
          showWelcomeCard={newUser}
          onCloseGuide={() => setNewUser1(false)} // close only the first
          onCloseWelcome={() => setNewUser(false)} // close only the second
          onOverlayClose={() => {
            // optional: overlay closes both
            setNewUser(false);
            setNewUser1(false);
          }}
          onProceed={() => {
            // navigate("/advanced-kyc");
            setNewUser(false);
            setNewUser1(false);
          }}
          mascotSrc="/images/cupi-mascot.png"
        />
      )}
    </>
  );
});

Kyc.propTypes = {
  className: PropTypes.string,
};

export default Kyc;
